import { makeStyles, withStyles } from '@material-ui/core';
import { compact } from 'lodash-es';
import { nanoid } from 'nanoid';

export const rem = (value: number, base = 16) => `${(value / base).toFixed(2)}rem`;

export const generateStyle = (style: any, name = '') => {
	const id = nanoid(6);
	const { REACT_APP_ID = 'AM-LOGIN' } = process.env;
	const names = compact([id, REACT_APP_ID, name]).join('-');
	return withStyles(style, { name: `${names}` });
};

export const generateStyleFC = (style: any, name = '') => {
	const id = nanoid(6);
	const { REACT_APP_ID = 'AM-LOGIN' } = process.env;
	const names = compact([id, REACT_APP_ID, name]).join('-');
	return makeStyles(style, { name: `${names}` });
};
